import React from "react";
import {styled} from "styletron-react";

export const CommonMargin = styled("div", (_: React.CSSProperties) => ({
  margin: "8px"
}));
